<template>
  <div class="my-list">
    <div class="tabs">
      <div :class="'tab-item '+(status==='1'?'tab-item-active':'')"
           @click="changeStatus('1')">成绩查询</div>
      <div :class="'tab-item '+(status==='2'?'tab-item-active':'')"
           @click="changeStatus('2')">申请考试</div>
      <div :class="'tab-item '+(status==='3'?'tab-item-active':'')"
           @click="changeStatus('3')">开始考试</div>
    </div>
    <div v-if="status==='1'">
      <el-table key="table1"
                :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%">
        <el-table-column type="index"
                         header-align="center"
                         align="center"
                         label="序号"></el-table-column>
        <el-table-column prop="title"
                         header-align="center"
                         align="center"
                         label="名称"></el-table-column>
        <el-table-column prop="submitTime"
                         header-align="center"
                         align="center"
                         label="考试时间"></el-table-column>
        <el-table-column prop="totalScore"
                         header-align="center"
                         align="center"
                         label="总分"></el-table-column>
        <el-table-column prop="finalScore"
                         header-align="center"
                         align="center"
                         label="考试分数"></el-table-column>
        <el-table-column prop="passScore"
                         header-align="center"
                         align="center"
                         label="及格(分)"></el-table-column>
        <el-table-column prop="pass"
                         header-align="center"
                         align="center"
                         label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isAllowStatus === 5">
              <font v-if="scope.row.pass"
                    style="color:#1D65A8;">及格</font>
              <font v-else-if="scope.row.pass === false"
                    style="color:#BF1B22;">不及格</font>
            </span>
            <font v-else-if="scope.row.isAllowStatus === 6"
                  style="color:#1D65A8;">已申请重考,预祝考试顺利</font>
            <span v-else-if="scope.row.isAllowStatus === 4">
              阅卷中
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="examCertificateApply"
                         header-align="center"
                         align="center"
                         label="申请证书状态">
          <template slot-scope="scope">
            <font v-if="scope.row.pass && scope.row.examCertificateApply === 0"
                  style="color:#BF1B22;">未申请</font>
            <font v-else-if="scope.row.pass && scope.row.examCertificateApply === 1"
                  style="color:#1D65A8;">申请中</font>
            <font v-else-if="scope.row.pass && scope.row.examCertificateApply === 2"
                  style="color:#1D65A8;">申请通过</font>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       v-if="!scope.row.pass && scope.row.isAllowStatus !== 4"
                       @click="reApplyHandle(scope.row)">申请重考</el-button>
            <el-button type="text"
                       size="small"
                       style="color: #1D65A8;"
                       v-if="scope.row.pass && scope.row.examCertificateApply === 0"
                       @click="applyCertificateHandle(scope.row)">申请证书</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else-if="status==='2'">
      <el-table key="table2"
                :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%">
        <el-table-column type="index"
                         header-align="center"
                         align="center"
                         label="序号"></el-table-column>
        <el-table-column prop="title"
                         header-align="center"
                         align="center"
                         label="考试名称"></el-table-column>
        <el-table-column prop="subject"
                         header-align="center"
                         align="center"
                         label="科目"></el-table-column>
        <el-table-column prop="typeName"
                         header-align="center"
                         align="center"
                         label="考试分类"></el-table-column>
        <el-table-column prop="descript"
                         header-align="center"
                         align="center"
                         label="考试内容简介"></el-table-column>
        <el-table-column prop="applyCount"
                         header-align="center"
                         align="center"
                         label="申请人数"></el-table-column>
        <el-table-column prop="status"
                         header-align="center"
                         align="center"
                         label="申请状态">
          <template slot-scope="scope">
            <font v-if="scope.row.status===0">可申请</font>
            <font v-else-if="scope.row.status===1">申请通过,预祝考试成功</font>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       style="color:#1D65A8;"
                       v-if="scope.row.status===0"
                       @click="applyHandle(scope.row)">我要申请</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else-if="status==='3'">
      <el-table key="table3"
                :data="dataList"
                border
                v-loading="dataListLoading"
                style="width: 100%">
        <el-table-column type="index"
                         header-align="center"
                         align="center"
                         label="序号"></el-table-column>
        <el-table-column prop="title"
                         header-align="center"
                         align="center"
                         label="考试名称"></el-table-column>
        <el-table-column prop="examCount"
                         header-align="center"
                         align="center"
                         label="考试题数"></el-table-column>
        <el-table-column prop="maxMinute"
                         header-align="center"
                         align="center"
                         label="考试时限">
          <template slot-scope="scope">
            {{scope.row.maxMinute}}分
          </template>
        </el-table-column>
        <el-table-column prop="totalScore"
                         header-align="center"
                         align="center"
                         label="总分"></el-table-column>
        <el-table-column prop="passScore"
                         header-align="center"
                         align="center"
                         label="及格分数"></el-table-column>
        <el-table-column header-align="center"
                         align="center"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       v-if="scope.row.active === 1 && scope.row.examCount !== 0"
                       @click="startExam(scope.row)">开始考试</el-button>
            <el-button type="text"
                       size="small"
                       v-if="scope.row.active === 1 && scope.row.examCount === 0"
                       @click="startXianxiaExam(scope.row)">线下考试</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img src="@/assets/img/good/noGood.png"
             alt="暂无数据">
      </div>
    </div>
    <el-pagination background
                   style="margin-top:10px;text-align: center;"
                   layout="prev, pager, next, total, jumper, slot"
                   prev-text="上一页"
                   next-text="下一页"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-size="10"
                   :pager-count="5"
                   :total="total">
    </el-pagination>
    <!-- <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      status: '1',
      dataList: [],
      dataListLoading: false,
      // 分页
      total: 0,
      currentPage: 1 // 当前页
      // totalPage: 4, // 总页数
      // lastOmit: '',
      // nextOmit: '...',
      // pageList: [1, 2, 3, 4, 5],
      // jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
    tabItemstatus () {
      return this.$route.query.status
    }
  },
  watch: {
    tabItemstatus (val) {
      if (val && Number(val) > 0) {
        this.status = val + ''
        this.getDataList(1)
      }
    }
  },
  mounted () {
    this.getDataList(this.currentPage)
  },
  methods: {
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`);
      this.getDataList(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getDataList()
      // console.log(`当前页: ${val}`);
    },
    // 成绩查询
    searchHaveDone (currentPage) {
      return this.$http.post(`/front/train/trainEmPaperUser/findExaminationResults`,
        {
          'page': currentPage,
          'limit': 10
        })
    },
    // 申请考试
    searchApplicationList (currentPage) {
      return this.$http.post(`/front/train/trainEmPaper/selectApplyPaperList`,
        {
          'page': currentPage,
          'limit': 10
        })
    },
    // 参加线下考试
    startXianxiaExam (val) {
      this.$confirm(`确定要参加线下考试`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handExamHandle(val.id)
      }).catch(() => { })
    },
    // 线下考试
    handExamHandle (id) {
      this.$request.get(`/front/train/trainEmPaper/findFormalExamSubject/${id}`)
        .then(data => {
          this.$http.post(`/front/train/trainEmUserAnswerRecord/saveExamResult`, {
            'paperId': id
          }).then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('申请成功')
              this.getDataList()
            }
          }).catch(() => { })
        })
    },
    // 开始考试
    searchExamList (currentPage) {
      return this.$http.post(`/front/train/trainEmPaper/findExamList`,
        {
          'page': currentPage,
          'limit': 10
        })
    },
    getDataList (currentPage = this.currentPage) {
      this.dataListLoading = true
      this.currentPage = currentPage
      let searchList = null
      if (this.status === '1') {
        searchList = this.searchHaveDone(currentPage)
      } else if (this.status === '2') {
        searchList = this.searchApplicationList(currentPage)
      } else if (this.status === '3') {
        searchList = this.searchExamList(currentPage)
      }
      searchList.then(data => {
        if (data && data.data && data.data.code === 0) {
          this.dataList = data.data.data.data || []
          this.total = data.data.data.count || 0
        } else {
          this.$message.error(data.data.msg || '查询失败')
          this.dataList = []
          this.total = 0
        }
        this.dataListLoading = false
      })
        .catch(() => {
          this.dataListLoading = false
          this.dataList = []
          this.total = 0
        })
    },
    changeStatus (index) {
      this.status = index
      this.dataList = []
      this.total = 0
      this.getDataList(1)
    },
    // 重新申请考试
    reApplyHandle (row) {
      this.$router.push({ name: 'applyExam', query: { id: row.paperId, title: row.title } })
    },
    // 申请考试
    applyHandle (row) {
      this.$router.push({ name: 'applyExam', query: { id: row.id, title: row.title } })
    },
    // 开始考试
    startExam (row) {
      this.$router.push({ name: 'startExam', query: { id: row.id, paperUserId: row.paperUserId } })
    },
    // 申请证书
    applyCertificateHandle (row) {
      this.$router.push({ name: 'applyCertificate', query: { id: row.id, title: row.cerName, name: row.name, mobile: row.mobile } })
    }
  }
}
</script>
<style scoped lang="scss">
.my-list {
  margin: 0 79px;
}
</style>
